import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { PATHWAYS_LEARNING } from "@/data/academy";
import { ArrowUpRight } from "lucide-react";

export default function LearningPathwaysHome() {
  return (
    <section className="bg-eucalyptus text-cream py-28 md:py-44" data-testid="pathways-home">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-16">
          <p className="overline text-ochre mb-7">Ways to learn</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">
            Several connected ways of learning — not one course.
          </h2>
        </Reveal>

        <div>
          {PATHWAYS_LEARNING.map((p, i) => (
            <Reveal key={p.title}>
              <Link
                to={p.to}
                data-testid={`pathway-home-${i}`}
                className="group grid grid-cols-1 md:grid-cols-[80px_1fr_auto] gap-4 md:gap-10 items-baseline py-8 border-t border-cream/15 hover:border-ochre transition-colors"
              >
                <span className="font-serif text-2xl text-ochre">{String(i + 1).padStart(2, "0")}</span>
                <span>
                  <span className="block font-serif text-2xl md:text-4xl group-hover:translate-x-2 transition-transform duration-300">{p.title}</span>
                  <span className="block text-cream/65 font-light mt-2 max-w-2xl">{p.body}</span>
                </span>
                <ArrowUpRight size={22} className="text-cream/40 group-hover:text-ochre group-hover:translate-x-1 group-hover:-translate-y-1 transition-all shrink-0" />
              </Link>
            </Reveal>
          ))}
          <div className="border-t border-cream/15" />
        </div>
      </div>
    </section>
  );
}
